import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { InputLabel, FormControl, Button, MenuItem } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Client } from '@horasys/bellplus/common/types';
import { getClients } from '../../services/clients.service';
import theme from 'theme';
import { CssSelect } from 'views/Common/CssSelect';

const PREFIX = 'LibraryHeader';

const classes = {
    formElement: `${PREFIX}-formElement`,
    wrapper: `${PREFIX}-wrapper`,
    headerWrapper: `${PREFIX}-headerWrapper`
};

const Root = styled('div')((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.formElement}`]: {
        marginTop: theme.spacing(2),
        minWidth: '100%',
        marginBottom: '20px',
    },

    [`& .${classes.wrapper}`]: {
        minWidth: '250px',
        backgroundColor: '#fff',
        position: 'absolute',
        right: 0,
        top: '-20px',
        zIndex: 99,
    },

    [`&.${classes.headerWrapper}`]: {
        position: 'relative',
    }
}));

const LibraryHeader = (props: any) => {
	const [cleintName, setClientName] = useState('');

	const [clientsList, setClientsList] = useState<Array<Client>>([]);



	useEffect(() => {
		const getDetails = async () => {
			try {
				const clientData: Array<Client> = await getClients();
				setClientsList(clientData);
			} catch (error) {
				console.error(error);
			}
		};
		props.role === 'admin' && getDetails();
	}, [props.role]);

	const handleInputDetails = (e: any) => {
		const {
			target: { value },
		} = e;
		const filterData = clientsList.filter((client) => client.id === value);
		setClientName(value);
		props.setClientName(value, filterData[0]);
	};

	return (
        <Root className={classes.headerWrapper} style={{padding:"15px"}}>
			{props.role === 'admin' && (
				<div className="">
					<FormControl
						variant="outlined"
						className={classes.formElement}
						disabled={false}>
						<InputLabel htmlFor="clientId">Client Name</InputLabel>
						<CssSelect
							name="clientId"
							id="clientId"
							label="Select Client"
							value={cleintName}
							onChange={handleInputDetails}>
							<MenuItem value="" />
							{clientsList != null &&
								clientsList.map((client: Client) => (
									<MenuItem value={client.id} key={client.id}>
										{client.companyName}
									</MenuItem>
								))}
						</CssSelect>
					</FormControl>
				</div>
			)}
			{(props.role === 'client' || cleintName) && (
				<div className="library-header ">
					<div className="d-flex">
						<Button
							style={{color:"#000"}}
							size="small"
							startIcon={<AddIcon />}
							onClick={props.addNewFolder}>
							New Folder
						</Button>
						<div className="m-1">
							<input
								accept="image/png, image/jpeg, video/mp4"
								className="d-none"
								id="contained-button-file"
								multiple
								type="file"
								onChange={props.handleUploadFile}
							/>
							<label htmlFor="contained-button-file">
								<Button
									style={{color:"#000"}}
									size="small"
									component="span"
									startIcon={<CloudUploadIcon />}>
									Upload
								</Button>
							</label>
						</div>
						{props.showDelete && (
							<Button
								size="small"
								startIcon={<DeleteIcon />}
								onClick={props.deleteFolder}>
								Delete
							</Button>
						)}
						{props.showRename && (
							<Button
								size="small"
								startIcon={<EditIcon />}
								onClick={props.renameFolder}>
								Rename
							</Button>
						)}
					</div>
				</div>
			)}
		</Root>
    );
};

export default LibraryHeader;
